import {PATH_BASED_SHAPES} from '../modelerX6/constants';

const JUNCTION_SHAPES = ['archimate:and-junction', 'archimate:or-junction'];

/**
 * Плагин: двойной клик по узлу — инлайн-редактор подписи (label).
 * Для Junction (And/Or) редактирование по двойному клику отключено — только через «Свойства элемента».
 */
export default {
	init(modeler, context) {
		const {graph, onPatch, viewIndex} = context;
		const VIEW_INDEX = viewIndex ?? 0;

		const onNodeDblclick = ({node, e}) => {
			if (!node?.id) return;
			const shape = typeof node.getShape === 'function' ? node.getShape() : node.shape;
			if (JUNCTION_SHAPES.includes(shape)) return;
			const cell = node;
			const cellView = graph.findViewByCell?.(cell);
			if (!cellView) return;
			const currentText = cell.getAttrByPath?.('label/text') ?? '';
			const nodeBBox = cell.getBBox?.();
			if (!nodeBBox) return;
			const inset = 4;
			const localRect = {
				x: nodeBBox.x + inset,
				y: nodeBBox.y + inset,
				width: Math.max(32, nodeBBox.width - inset * 2),
				height: Math.max(20, nodeBBox.height - inset * 2),
			};
			const clientRect = graph.localToClient?.(localRect);
			if (!clientRect) return;
			modeler._openLabelEditor({
				cell,
				graph,
				clientRect: {
					x: clientRect.x,
					y: clientRect.y,
					width: Math.max(clientRect.width, 48),
					height: Math.max(clientRect.height, 20),
				},
				initialValue: typeof currentText === 'string' ? currentText : '',
				onCommit: newText => {
					const id = cell.id;
					cell.setAttrByPath?.('label/text', newText);
					const viewElement = modeler._findViewElementById(id);
					if (viewElement) {
						viewElement.label = newText;
						const elementRef = modeler._getElementRef(viewElement);
						if (elementRef && typeof elementRef.name !== 'undefined') {
							if (elementRef.set) elementRef.set('name', newText);
							else elementRef.name = newText;
						}
					}
					onPatch({
						patches: [
							{
								op: 'updateElementLabel',
								viewIndex: VIEW_INDEX,
								identifier: id,
								elementName: newText,
							},
						],
					});
					// Group/Grouping: path язычка зависит от ширины подписи — пересчитать body.
					if (PATH_BASED_SHAPES.includes(shape) && modeler._nodeFactory?.update) {
						modeler._nodeFactory.update(cell, {label: newText});
					}
				},
			});
		};

		const onCellDblclick = args => {
			const cell = args?.cell ?? args?.node;
			if (cell?.isNode?.()) onNodeDblclick({node: cell, e: args?.e});
		};

		graph.on('node:dblclick', onNodeDblclick);
		graph.on('node:magnet:dblclick', onNodeDblclick);
		graph.on('cell:dblclick', onCellDblclick);

		return () => {
			graph.off('node:dblclick', onNodeDblclick);
			graph.off('node:magnet:dblclick', onNodeDblclick);
			graph.off('cell:dblclick', onCellDblclick);
		};
	},
};
